// React Imports
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';

// Components
import Header from '../components/Header';
import {Pages} from '../common/vars';
import TextBlock from "../elements/TextBlock";
import FooterLogo from "../elements/FooterLogo";
import Map from "../elements/Map";

import '../../styles/pages/contact.css';
import '../../styles/pages/page.css';

class ContactPage extends Component {

    page = Pages[5];

    content = this.page.content;

    render() {
        return (
            <article className="page contact">
                <Header image={this.page.img} svg={this.page.svg} title={this.page.name} subtitle={this.page.subtitle}/>
                <div className="page__content">
                    <TextBlock title={this.content[0].title} content={this.content[0].content}
                               className="text-block--first text-block--left text-block--small-left" />
                    <div className="contact__map">
                        <Map/>
                        <div className="contact__info">
                            <div className="contact__info-content">
                                <div className="contact__info-block contact__info-title">
                                    <h4 className="contact__info-line contact__info-line--emphasys">Koalition</h4>
                                    <h4 className="contact__info-line contact__info-line--emphasys">Yellow Machine Studio</h4>
                                </div>
                                <div className="contact__info-block contact__info-address" href="#">
                                    <span className="contact__info-line">Eutokia</span>
                                    <span className="contact__info-line">Bilbao-Galdakao Errepidea 10 3rd</span>
                                    <span className="contact__info-line">48004 Bilbao Bizkaia</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <FooterLogo/>
            </article>
        );
    }
}

const mapStateToProps = state => {
    return {
        contact: state.contact,
    }
};

export default withRouter(connect(mapStateToProps)(ContactPage));


// WEBPACK FOOTER //
// ./src/js/pages/ContactPage.js